import React from 'react';

interface SparkleIconProps {
    size?: number;
    className?: string;
}

/** Inline "AI magic" mark — a four-point sparkle with two smaller companions.
 *  Inherits the button's colour via currentColor (no emoji anywhere in the UI). */
const SparkleIcon: React.FC<SparkleIconProps> = ({size = 20, className}) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.6 2.4a.65.65 0 0 0-1.2 0l-1.2 3.4a4.5 4.5 0 0 1-2.7 2.7l-3.4 1.2a.65.65 0 0 0 0 1.2l3.4 1.2a4.5 4.5 0 0 1 2.7 2.7l1.2 3.4a.65.65 0 0 0 1.2 0l1.2-3.4a4.5 4.5 0 0 1 2.7-2.7l3.4-1.2a.65.65 0 0 0 0-1.2l-3.4-1.2a4.5 4.5 0 0 1-2.7-2.7l-1.2-3.4Z"
            fill="currentColor"
        />
        <path
            d="M18.75 15.4a.35.35 0 0 0-.66 0l-.44 1.24a2 2 0 0 1-1.21 1.21l-1.24.44a.35.35 0 0 0 0 .66l1.24.44a2 2 0 0 1 1.21 1.21l.44 1.24a.35.35 0 0 0 .66 0l.44-1.24a2 2 0 0 1 1.21-1.21l1.24-.44a.35.35 0 0 0 0-.66l-1.24-.44a2 2 0 0 1-1.21-1.21l-.44-1.24Z"
            fill="currentColor"
        />
        <path
            d="M5.1 1.6a.3.3 0 0 0-.57 0l-.35.98a1.7 1.7 0 0 1-1.03 1.03l-.98.35a.3.3 0 0 0 0 .57l.98.35a1.7 1.7 0 0 1 1.03 1.03l.35.98a.3.3 0 0 0 .57 0l.35-.98A1.7 1.7 0 0 1 6.48 4.9l.98-.35a.3.3 0 0 0 0-.57l-.98-.35A1.7 1.7 0 0 1 5.45 2.6L5.1 1.6Z"
            fill="currentColor"
        />
    </svg>
);

export default SparkleIcon;
